import { Component, Input, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { ApiResult } from 'src/app/models/PromiseResult';

@Component({
    selector: 'app-error-messages[api_result]',
    templateUrl: './error-messages.component.html',
    styleUrls: ['./error-messages.component.css']
})
@TraceClassDecorator()
export class ErrorMessagesComponent implements OnInit {
    @Input('api_result')
    api_result: ApiResult = new ApiResult(true);

    constructor() {}

    ngOnInit() {}
}
